import script from "./GalaxyMap.vue?vue&type=script&setup=true&lang=js"
export * from "./GalaxyMap.vue?vue&type=script&setup=true&lang=js"

import "./GalaxyMap.vue?vue&type=style&index=0&id=1c127323&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c127323"]])

export default __exports__